// src/components/NotFoundPage.js

import React, { useEffect, useRef } from 'react';
import './Notfound.css';
import card from "../../NFC Assets/Cards/Gold Transparent Card.png"
// In a real app, you would use this instead of an <a> tag
// import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const sceneRef = useRef(null);
  const backgroundTextRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const scene = sceneRef.current;
    const backgroundText = backgroundTextRef.current;
    const container = containerRef.current;
    if (!scene || !backgroundText || !container) return;

    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { clientWidth, clientHeight } = container;
      
      const x = (clientX / clientWidth) - 0.5;
      const y = (clientY / clientHeight) - 0.5;

      // Foreground (moves more)
      const rotateY = x * 20;
      const rotateX = -y * 20;
      scene.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

      // Background (moves less, creating depth)
      const bgRotateY = x * 5;
      const bgRotateX = -y * 5;
      backgroundText.style.transform = `translate(-50%, -50%) rotateX(${bgRotateX}deg) rotateY(${bgRotateY}deg)`;
    };
    
    const handleMouseLeave = () => {
        scene.style.transform = 'rotateX(0deg) rotateY(0deg)';
        backgroundText.style.transform = 'translate(-50%, -50%) rotateX(0deg) rotateY(0deg)';
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div className="notfoundpage-container" ref={containerRef}>
      {/* Background Elements */}
      <div className="notfoundpage-background-grid"></div>
      <div className="notfoundpage-data-motes">
        <span></span><span></span><span></span><span></span>
      </div>
      <div className="notfoundpage-scan-line"></div>
      <div className="notfoundpage-background-text" ref={backgroundTextRef}>404</div>

      {/* Corner Brackets for framing */}
      <div className="notfoundpage-corner-bracket top-left"></div>
      <div className="notfoundpage-corner-bracket top-right"></div>
      <div className="notfoundpage-corner-bracket bottom-left"></div>
      <div className="notfoundpage-corner-bracket bottom-right"></div>
      
      <div className="notfoundpage-scene" ref={sceneRef}>
        <div className="notfoundpage-content">
          <div className="notfoundpage-nfc-animation">
            <div className="notfoundpage-nfc-card">
              {/* <span className="notfoundpage-wifi-icon"></span> */}
              {/* <div className="notfoundpage-circuit-lines"></div> */}
              <img src={card} style={{height:'149px', width:'249px'}}/>
            </div>
            <div className="notfoundpage-phone">
              <div className="notfoundpage-phone-screen">
                <div className="notfoundpage-error-code">404</div>
              </div>
            </div>
            <div className="notfoundpage-nfc-waves">
              <span></span>
              <span></span>
              <span></span>
              <div className="notfoundpage-glitch-line"></div>
            </div>
          </div>
          
          <h1 className="notfoundpage-error-title">
            <span className="notfoundpage-char">C</span>
            <span className="notfoundpage-char">o</span>
            <span className="notfoundpage-char">n</span>
            <span className="notfoundpage-char">n</span>
            <span className="notfoundpage-char">e</span>
            <span className="notfoundpage-char">c</span>
            <span className="notfoundpage-char">t</span>
            <span className="notfoundpage-char">i</span>
            <span className="notfoundpage-char">o</span>
            <span className="notfoundpage-char">n</span>
            <span className="notfoundpage-char"> </span>
            <span className="notfoundpage-char">L</span>
            <span className="notfoundpage-char">o</span>
            <span className="notfoundpage-char">s</span>
            <span className="notfoundpage-char">t</span>
          </h1>
          <p className="notfoundpage-error-message">
            The page you tried to access could not be found on our network.
          </p>
          
          <a href="/" className="notfoundpage-home-button">
            <span>Re-establish Connection</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;